<template>
  <div class="bottomContent">
    <!-- 开关关闭的 -->
    <div
      class="bottomw"
      v-if="isconfigforChannel?.ability?.used?.func?.domain_name_change != 1"
    >
      <div class="bottomz">
        <div class="bottomL">
          <div class="lTitle">
            关于我们
            <!-- <img src="@/assets/home/botmlogo.svg" alt=""> -->
          </div>
          <div class="lP">
            在数字化信息爆炸的时代，我们——电脑滚动录屏团队，致力于为用户提供最便捷、最高效、最全面的去录屏方案。我们是一家专注于录屏技术研发与服务的专业网站，致力于为用户提供高效、便捷、安全的录屏解决方案。自成立以来，我们始终秉持着技术创新、用户至上的核心价值观，不断探索和优化录屏技术，以满足用户在各种场景下的需求。
          </div>
        </div>

        <div class="bottomR">
          <div
            class="rTitle"
            v-if="isconfigforChannel?.ability?.used.comm.is_active == '1'"
          >
            联系方式
          </div>
          <div
            class="rItem"
            v-if="
              isconfigforChannel?.ability?.used.comm.is_active == '1' &&
              isconfigforChannel?.ability?.used.func.online_service_info !==
                '' &&
              isconfigforChannel?.ability?.used.func.online_service_info !== '0'
            "
          >
            <!-- <img src="@/assets/bottom/dh.png" alt=""> -->
            <span
              >在线客服：<a
                :href="
                  isconfigforChannel?.ability?.used.func.online_service_info
                "
                style="color: #999999; font-size: 16px"
                >点击跳转</a
              ></span
            >
            <span></span>
          </div>
          <div
            class="rItem"
            v-if="
              isconfigforChannel?.ability?.used.comm.is_active == '1' &&
              isconfigforChannel?.ability?.used.func.customer_serv !== '' &&
              isconfigforChannel?.ability?.used.func.customer_serv !== '0'
            "
          >
            <span
              >电话：{{
                isconfigforChannel?.ability?.used.func.customer_serv
              }}</span
            >
            <span></span>
          </div>
          <!-- <div
            class="rItem"
            v-if="
              isconfigforChannel?.ability?.used.comm.is_active == '1' &&
              isconfigforChannel?.ability?.used.func.corporation !== '' &&
              isconfigforChannel?.ability?.used.func.corporation !== '0'
            "
          >
            <span
              >公司：{{
                isconfigforChannel?.ability?.used.func.corporation
              }}</span
            >
            <span></span>
          </div>
          <div
            class="rItem"
            v-if="
              isconfigforChannel?.ability?.used.comm.is_active == '1' &&
              isconfigforChannel?.ability?.used.func.location !== '' &&
              isconfigforChannel?.ability?.used.func.location !== '0'
            "
          >
            <span
              >地址：{{ isconfigforChannel?.ability?.used.func.location }}</span
            >
            <span></span>
          </div> -->

          <div class="rItem">
            <span> 公司：成都秋月寒江网络科技有限公司 </span>
            <span></span>
          </div>
          <div class="rItem">
            <span>
              地址：中国（四川）自由贸易试验区成都市天府新区兴隆街道集萃街619号天府海创园2-2号楼17层
            </span>
            <span></span>
          </div>
        </div>
      </div>

      <!-- <div class="hx"></div> -->
      <div class="threebtn">
        <div
          class="btnitem"
          v-if="
            isconfigforChannel?.standard_conf?.agreement_content?.comm
              .is_active == '1' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .user_agreement !== '' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .user_agreement !== '0'
          "
        >
          <span
            ><a
              :href="
                isconfigforChannel?.standard_conf?.agreement_content?.func
                  .user_agreement
              "
              style="color: #999999; font-size: 14px"
              >《用户协议》、</a
            ></span
          >
          <span></span>
        </div>
        <div
          class="btnitem"
          v-if="
            isconfigforChannel?.standard_conf?.agreement_content?.comm
              .is_active == '1' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .privacy_policy !== '' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .privacy_policy !== '0'
          "
        >
          <span
            ><a
              :href="
                isconfigforChannel?.standard_conf?.agreement_content?.func
                  .privacy_policy
              "
              style="color: #999999; font-size: 14px"
              >《隐私政策》</a
            ></span
          >
          <span></span>
        </div>
        <div
          class="btnitem"
          v-if="
            isconfigforChannel?.standard_conf?.agreement_content?.comm
              .is_active == '1' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .refund_policy !== '' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .refund_policy !== '0' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .refund_policy
          "
        >
          <span
            ><a
              :href="
                isconfigforChannel?.standard_conf?.agreement_content?.func
                  .refund_policy
              "
              style="color: #999999; font-size: 14px"
              >、《退款政策》</a
            >
          </span>
          <span></span>
        </div>
      </div>

      <!-- <div
        class="dbR"
        v-if="
          isconfigforChannel?.ability?.used.comm.is_active == '1' &&
          isconfigforChannel?.ability?.used?.func.bottom_content !== '' &&
          isconfigforChannel?.ability?.used?.func.bottom_content !== '0'
        "
      >
        Copyright © 2024
        {{ isconfigforChannel?.ability?.used.func.corporation }} All Rights
        Reserved. {{ isconfigforChannel?.ability?.used?.func.bottom_content }}
      </div> -->

      <div class="dbR">蜀ICP备2024109012号</div>
    </div>

    <div
      class="bottomw"
      v-if="isconfigforChannel?.ability?.used?.func?.domain_name_change == 1"
    >
      <div class="bottomz">
        <div class="bottomL">
          <div class="lTitle">关于我们</div>
          <div class="lP">
            在数字化信息爆炸的时代，我们——电脑滚动录屏团队，致力于为用户提供最便捷、最高效、最全面的去录屏方案。我们是一家专注于录屏技术研发与服务的专业网站，致力于为用户提供高效、便捷、安全的录屏解决方案。自成立以来，我们始终秉持着技术创新、用户至上的核心价值观，不断探索和优化录屏技术，以满足用户在各种场景下的需求。
          </div>
        </div>

        <div class="bottomR">
          <div
            class="rTitle"
            v-if="
              isnewconfig?.online_service_info &&
              isnewconfig.online_service_info != ''
            "
          >
            联系方式
          </div>
          <div
            class="rItem"
            v-if="
              isnewconfig?.online_service_info &&
              isnewconfig.online_service_info != ''
            "
          >
            <!-- <img src="@/assets/bottom/dh.png" alt=""> -->
            <span
              >在线客服：<a
                :href="isnewconfig.online_service_info"
                style="color: #999999; font-size: 16px"
                >点击跳转</a
              ></span
            >
            <span></span>
          </div>
          <div
            class="rItem"
            v-if="
              isnewconfig?.customer_serv &&
              isnewconfig.customer_serv != '' &&
              isnewconfig.customer_serv != '0'
            "
          >
            <span>电话：{{ isnewconfig?.customer_serv }}</span>
            <span></span>
          </div>
          <!-- <div
            class="rItem"
            v-if="
              isnewconfig?.corporation &&
              isnewconfig.corporation !== '' &&
              isnewconfig.corporation !== '0'
            "
          >
            <span>公司：{{ isnewconfig.corporation }}</span>
            <span></span>
          </div>
          <div
            class="rItem"
            v-if="
              isnewconfig?.location &&
              isnewconfig.location !== '' &&
              isnewconfig.location !== '0'
            "
          >
            <span>地址：{{ isnewconfig.location }}</span>
            <span></span>
          </div> -->

          <div class="rItem">
            <span>公司：成都秋月寒江网络科技有限公司</span>
            <span></span>
          </div>
          <div class="rItem">
            <span
              >地址：中国（四川）自由贸易试验区成都市天府新区兴隆街道集萃街619号天府海创园2-2号楼17层</span
            >
            <span></span>
          </div>
        </div>
      </div>

      <!-- <div class="hx"></div> -->
      <div class="threebtn">
        <div
          class="btnitem"
          v-if="
            isconfigforChannel?.standard_conf?.agreement_content?.comm
              .is_active == '1' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .user_agreement !== '' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .user_agreement !== '0'
          "
        >
          <span
            ><a
              :href="
                isconfigforChannel?.standard_conf?.agreement_content?.func
                  .user_agreement
              "
              style="color: #999999; font-size: 14px"
              >《用户协议》、</a
            ></span
          >
          <span></span>
        </div>
        <div
          class="btnitem"
          v-if="
            isconfigforChannel?.standard_conf?.agreement_content?.comm
              .is_active == '1' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .privacy_policy !== '' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .privacy_policy !== '0'
          "
        >
          <span
            ><a
              :href="
                isconfigforChannel?.standard_conf?.agreement_content?.func
                  .privacy_policy
              "
              style="color: #999999; font-size: 14px"
              >《隐私政策》</a
            ></span
          >
          <span></span>
        </div>
        <div
          class="btnitem"
          v-if="
            isconfigforChannel?.standard_conf?.agreement_content?.comm
              .is_active == '1' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .refund_policy !== '' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .refund_policy !== '0' &&
            isconfigforChannel?.standard_conf?.agreement_content?.func
              .refund_policy
          "
        >
          <span
            ><a
              :href="
                isconfigforChannel?.standard_conf?.agreement_content?.func
                  .refund_policy
              "
              style="color: #999999; font-size: 14px"
              >、《退款政策》</a
            >
          </span>
          <span></span>
        </div>
      </div>

      <!-- <div
        class="dbR"
        v-if="
          isnewconfig?.bottom_content &&
          isnewconfig.bottom_content !== '' &&
          isnewconfig.bottom_content !== '0'
        "
      >
        Copyright © 2024 {{ isnewconfig.corporation }} All Rights Reserved.
        {{ isnewconfig.bottom_content }}
      </div> -->

      <div class="dbR">蜀ICP备2024109012号</div>
    </div>
  </div>
</template>

<script>
import { getspQuest } from "@/api/upload";
import { mapGetters } from "vuex";
import assist from "@/utils/commonality";
export default {
  mixins: [],
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["isconfigforChannel", "isnewconfig"]),
  },
  watch: {},
  created() {},
  mounted() {
    this.getCfgForChannel();
  },
  methods: {
    async getCfgForChannel() {
      await this.$store.dispatch("getconfigforChannel");
      this.$nextTick(async () => {
        console.log(this.$store.getters.isconfigforChannel);
        console.log(this.$store.getters.isnewconfig);

        const onlineServiceInfo =
          this.isconfigforChannel?.ability?.used?.func?.online_service_info;

        if (
          onlineServiceInfo === null ||
          onlineServiceInfo === undefined ||
          onlineServiceInfo == ""
        ) {
          await getspQuest("/dingbot/send", "get", "35", {
            text: "没有配置在线客服",
            errno: 1,
          });
        }

        const customer_serv =
          this.isconfigforChannel?.ability?.used?.func?.customer_serv;

        if (
          customer_serv === null ||
          customer_serv === undefined ||
          customer_serv == ""
        ) {
          await getspQuest("/dingbot/send", "get", "35", {
            text: "没有配置电话",
            errno: 1,
          });
        }

        const corporation =
          this.isconfigforChannel?.ability?.used?.func?.corporation;

        if (
          corporation === null ||
          corporation === undefined ||
          corporation == ""
        ) {
          await getspQuest("/dingbot/send", "get", "35", {
            text: "没有配置公司",
            errno: 1,
          });
        }

        const location = this.isconfigforChannel?.ability?.used?.func?.location;
        if (location === null || location === undefined || location == "") {
          await getspQuest("/dingbot/send", "get", "35", {
            text: "没有配置地址",
            errno: 1,
          });
        }

        const is_active =
          this.isconfigforChannel?.ability?.used?.comm?.is_active;

        if (is_active === null || is_active === undefined || is_active == "") {
          await getspQuest("/dingbot/send", "get", "35", {
            text: "底部配置is_active为0",
            errno: 0,
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.bottomContent {
  width: 100%;
  background-color: #000;
  padding-bottom: 30px;
  min-width: 1080px;
}
.bottomw {
  width: 80%;
  margin: 0 auto;
  background-color: #000;
  padding-top: 30px;

  .bottomz {
    display: flex;
    justify-content: space-between;
    color: #fff;
    margin-bottom: 15px;
  }

  .bottomL {
    width: 45%;
    padding-bottom: 20px;
    .lTitle {
      font-size: 18px;
      margin-bottom: 15px;
      img {
        width: 160px;
      }
    }
    .lP {
      color: #999999;
      font-size: 16px;
      line-height: 1.5;
      letter-spacing: 0.1em;
    }
  }

  .bottomR {
    width: 30%;
    .rTitle {
      font-size: 18px;
      margin-bottom: 20px;
    }
    .rItem {
      display: flex;
      align-items: center;
      margin: 15px 0;
      // max-width: 300px;
      font-size: 16px;
      img {
        width: 13px;
        height: 13px;
        display: block;
        margin-right: 10px;
      }
      span {
        font-size: 16px;
        color: #999999;
      }
    }
  }
}

.hx {
  width: 100%;
  height: 1px;
  background-color: #404040;
}

.db {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 20px;
  .dbL {
    display: flex;
    align-items: center;
  }
  .dbLItem {
    display: flex;
    align-items: center;
    margin-right: 20px;
    color: #999999;
    span {
      font-size: 14px;
    }
    img {
      width: 24px;
      height: 28px;
      margin-right: 10px;
    }
  }
}
.dbR {
  font-size: 14px;
  color: #999999;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.threebtn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 12px;

  a {
    text-decoration: none;
  }
}
</style>
